import { styled } from '@mui/material/styles';

const IconWrap = styled('span')({
  display: 'inline-flex',
});

export function IncognitoIcon() {
  return (
    <IconWrap>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path
          d="M4 9.5L7.5 6.5H16.5L20 9.5"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 10L7.5 6.5"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M18 10L16.5 6.5"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M8.25 14.25C8.25 15.4926 7.24264 16.5 6 16.5C4.75736 16.5 3.75 15.4926 3.75 14.25C3.75 13.0074 4.75736 12 6 12C7.24264 12 8.25 13.0074 8.25 14.25Z"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path
          d="M20.25 14.25C20.25 15.4926 19.2426 16.5 18 16.5C16.7574 16.5 15.75 15.4926 15.75 14.25C15.75 13.0074 16.7574 12 18 12C19.2426 12 20.25 13.0074 20.25 14.25Z"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path
          d="M8.25 14.25H15.75"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    </IconWrap>
  );
}
